import { routes } from "src/constants/routes.constants.ts";

export const loginPageRoute = {
  path: routes.root.root,
  lazy: () => import("src/auth/pages/LoginPage/LoginPage.tsx"),
};
